/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { SimpleForm, useGetOne, EditButton, Toolbar } from "react-admin";
import { Card, CardHeader } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextField as MuiTextField } from "@material-ui/core";
import { React } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(5),
  },
}));

// Fix for "React html element doesnt understand basePath prop, etc..."
const TextField = ({ basePath, ...props }) => <MuiTextField {...props} />;

export const CardView = ({ staticContext, ...props }) => {
  const classes = useStyles();
  const { data } = useGetOne("billing/credit-card", "");

  const cardNumber = data?.last4 ? `•••• •••• •••• ${data.last4}` : "";
  const expDate =
    data?.expMonth && data?.expYear ? `${data?.expMonth}/${data?.expYear}` : "";

  return (
    <Card classes={classes}>
      <CardHeader title="Payment Details" />
      <SimpleForm
        toolbar={
          <Toolbar {...props}>
            <EditButton
              size="medium"
              variant="contained"
              basePath="/billing/credit-card/edit"
              record={data}
            />
          </Toolbar>
        }
      >
        <TextField
          label="Credit Card Number"
          name="ccnumber"
          variant="outlined"
          required
          fullWidth
          helperText=" "
          value={cardNumber}
          disabled
        />
        <TextField
          label="Expiration Date"
          name="ccexp"
          variant="outlined"
          required
          fullWidth
          value={expDate}
          helperText=" "
          disabled
        />
      </SimpleForm>
    </Card>
  );
};
